export default "{\n    \"label_one\": \"Membre de l'équipe\",\n    \"label_other\": \"{{count}} membres de l'équipe\"\n}\n"